// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Z0-z","smallCardRow":"_0-z","largeCardRow":"a1-z","productSearchRow":"b1-z","curatedRow":"c1-z"};